module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB0SURBVHgB7ZQxCoAwEARvtRdsJaCP0N6fab6nr1Dyj5gUgWARkLhFIFPdNXscDItJzZsV7PIzPvM2hw47RrVYIXGZE2FuIFYLAfcRJbfCAyy9Y3w+Ve+Ytu8G5zpWIVJVL4Msvd8NnTyUq3fc0Cmy2vuLtg8cpSNs1ZGcKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/Navbar/burger.png
// module id = 92
// module chunks = 0